
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { ViewColumn } from "@/utils/views/view-column";
import Vue from "vue";
import AppEditColumn from "./ColumnEdit.vue";
import AppColumnHightlights from "./ColumnHighlights.vue";

export default Vue.extend({
	data() {
		return {
			editColumnModal: false,
			editingColumn: new ViewColumn(),
			editingIndex: -1,
			browses: [] as Browse[],
			isColumnNew: false,
			toEditHighlightsColumn: null as null | ViewColumn
		};
	},
	props: {
		view: {
			type: Object as () => View,
		}
	},
	computed: {
		browse(): Browse | undefined {
			for (let browse of this.browses) {
				if (this.view.BrowseID == browse.ID) {
					return browse;
				}
			}
			return undefined;
		},
	},
	methods: {
		cancel() {
			this.editColumnModal = false;
		},
		save() {
			if (this.editingIndex == -1) {
				this.view.Columns.push(this.editingColumn);
			} else {
				this.view.Columns[this.editingIndex] = this.editingColumn;
			}
			this.editColumnModal = false;
		},
		editColumn(column: ViewColumn) {
			this.editingColumn = new ViewColumn(column);
			this.editingIndex = this.view.Columns.indexOf(column);
			this.isColumnNew = false;
			this.editColumnModal = true;
		},
		addColumn() {
			this.editingColumn = new ViewColumn();
			this.editingIndex = -1;
			this.isColumnNew = true;
			this.editColumnModal = true;
		},
		removeColumn(index: number) {
			this.view.Columns.splice(index, 1);
		},
		getColumnFriendlyName(column: ViewColumn): string {
			if (!this.browse) return "";
			let field = this.browse.type.getField(column.Property);
			if (!field) {
				return "ERROR";
			}
			return field.getPropertyTranslation();
		},
		editHighlights(column:ViewColumn){
			this.toEditHighlightsColumn = column;
		}
	},
	async created() {
		this.browses = await BrowseService.getBrowses();
	},
	components: {
		AppEditColumn,
		AppColumnHightlights
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
